export const CREDITAPP_API_URLS = {
  Error_Handling_API_URL: '/api/sitecore/SharedPage/LogJsError',
  SAVE_CREDIT_APPLICATION: '/api/sitecore/CreditApplication4/SaveCreditApplication',
  SAVE_PREQUALIFICATION: '/api/sitecore/CreditApplication4/PreQualificationSubmission',
  GET_CREDIT_APPLICATION: '/api/sitecore/CreditApplication4/GetCreditApplication',
  BUY_NOW_LEAD_SUBMISSION: '/api/sitecore/BuyNow/PersonalDetails',
  BANK_API_URL: '/api/test',
  STAND_ALONE_LEAD_TRANSACTION: '/api/sitecore/CreditApplication4/StandAloneLeadTransaction',
};

export const UDO = Object.freeze({
  NotSet: '(not set)',
  VIN: 'VIN',
  NO_VIN: 'No VIN'
});

export const BANK_API = {
  ROUTEONE_URL: '/api/test',
};
